/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const BrokerPspDetailsR = t.interface({
  broker_psp_code: t.string,

  description: t.string,

  enabled: t.boolean,

  extended_fault_bean: t.boolean
});

// optional attributes
const BrokerPspDetailsO = t.partial({});

export const BrokerPspDetails = t.intersection(
  [BrokerPspDetailsR, BrokerPspDetailsO],
  "BrokerPspDetails"
);

export type BrokerPspDetails = t.TypeOf<typeof BrokerPspDetails>;
